export default function () {
  return {
    orders_cart: {
      orders: [],
      ordersCurrentPage: 1,
      ordersLastPage: 1,
      ordersPerPage: 0,
      ordersTotal: 0,
    },
    orders_deviz: {
      orders: [],
      ordersCurrentPage: 1,
      ordersLastPage: 1,
      ordersPerPage: 0,
      ordersTotal: 0,
    },
    ordersLoading: false,
    indexPage: null,
    comanda_nr: '',
    clientkey: '',
    erp: null,
    datefrom: '',
    dateto: ''
  }
}
